<script>
    import {onMount} from 'svelte'
    import questionIcon from './question.svg'
    import headIcon from './head.svg'
    import bodyIcon from './body.svg'
    import tailIcon from './tail.svg'

    export let move
    export let rarity
    export let elements

    let rarityId
    let moved = false

    const selected = [
        elements[0].element+'-'+elements[0].subElement,
        elements[1].element+'-'+elements[1].subElement,
        elements[2].element+'-'+elements[2].subElement,
    ]

    let slotSymbols = [
        ['water-0', 'wind-0', 'earth-0', 'crystal-0', 'iron-0', 'fire-0', 'light-0', 'dark-0', 'electrical-0', 'water-1', 'wind-1', 'earth-1', 'crystal-1', 'iron-1', 'fire-1', 'light-1', 'dark-1', 'electrical-1', 'water-2', 'wind-2', 'earth-2', 'crystal-2', 'iron-2', 'fire-2', 'light-2', 'dark-2', 'electrical-2'],
        ['light-0', 'dark-0', 'electrical-0', 'water-1', 'wind-1', 'earth-1', 'crystal-1', 'iron-1', 'fire-1', 'light-1', 'dark-1', 'electrical-1', 'water-2', 'wind-2', 'earth-2', 'crystal-2', 'iron-2', 'fire-2', 'light-2', 'dark-2', 'electrical-2', 'water-0', 'wind-0', 'earth-0', 'crystal-0', 'iron-0', 'fire-0'],
        ['electrical-1', 'water-2', 'wind-2', 'earth-2', 'crystal-2', 'iron-2', 'fire-2', 'light-2', 'dark-2', 'electrical-2', 'water-0', 'wind-0', 'earth-0', 'crystal-0', 'iron-0', 'fire-0', 'light-0', 'dark-0', 'electrical-0', 'water-1', 'wind-1', 'earth-1', 'crystal-1', 'iron-1', 'fire-1', 'light-1', 'dark-1']
    ]

    $: {
        if (move) {
            setTimeout(() => {
                moved = true
            }, 400)
        }
    }

    function createSymbolImage(symbol) {
        const img = document.createElement('img')
        img.classList.add('slot-symbol')
        img.src = '/images/elements/'+symbol+'.svg'
        return img
    }

    function createDefaultSymbol() {
        const img = document.createElement('img')
        img.classList.add('slot-symbol')
        img.src = questionIcon
        return img
    }

    function spin() {
        const slots = document.querySelectorAll('.slot-symbol')
        let completedSlots = 0

        slots.forEach((slot, index) => {
            const symbols = slot.querySelector('.symbols')
            const symbolHeight = 110 // symbols.querySelector('.symbol')?.clientHeight

            slotSymbols[index] = slotSymbols[index].filter(item => item !== selected[index])
            slotSymbols[index].unshift(selected[index])

            slotSymbols[index].forEach(symbol => {
                symbols.appendChild(createSymbolImage(symbol))
            })

            slotSymbols[index].forEach(symbol => {
                symbols.appendChild(createSymbolImage(symbol))
            })

            symbols.appendChild(createDefaultSymbol())

            const randomOffset = Math.floor(symbols.childElementCount - 1) * symbolHeight
            symbols.style.bottom = `-${randomOffset}px`

            symbols.addEventListener('transitionend', () => {
                completedSlots++
                if (completedSlots === slots.length) {
                    rarityId = rarity
                }
            }, { once: true })
        })
    }

    onMount(() => {
        setTimeout(() => {
            spin()
        }, 100)
    })
</script>

<div class="slot-wrapper rarity-id-{rarityId}" class:move={move} class:moved={moved}>
    <div class="icons">
        <img src="{headIcon}" class="head" alt="">
        <img src="{bodyIcon}" class="body" alt="">
        <img src="{tailIcon}" class="tail" alt="">
    </div>
    <div class="slot-container">
        <div class="slot-symbol">
            <div class="symbols"></div>
        </div>
        <div class="slot-symbol">
            <div class="symbols"></div>
        </div>
        <div class="slot-symbol">
            <div class="symbols"></div>
        </div>
    </div>
</div>

<style>
    .slot-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        transition: .4s;
    }

    .move {
        z-index: 3;
        margin: 74px 0 0 79px;
        transform: translate(-50%, -50%) scale(0.5);
    }

    .moved {
        opacity: 0;
        z-index: 0;
    }

    .slot-container {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
    }

    div.slot-symbol {
        width: 112px;
        height: 112px;
        border: 1px solid rgba(0, 0, 0, 0.6);
        border-radius: 20px;
        margin: 0 2px;
        padding: 0;
        display: inline-block;
        overflow: hidden;
        position: relative;
        background: #5a5d6c;
        box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.4) inset;
        transition: .4s;
    }

    .rarity-id-0 div.slot-symbol {
        background: #5fcc8d;
    }

    .rarity-id-1 div.slot-symbol {
        background: #4046c4;
    }

    .rarity-id-2 div.slot-symbol {
        background: #a940c6;
    }

    .rarity-id-3 div.slot-symbol {
        background: #e8b710;
    }

    .rarity-id-4 div.slot-symbol {
        background: #c03f40;
    }

    .move div.slot-symbol {
        border: 1px solid transparent;
        margin: 0 -19px;
        background: transparent;
        box-shadow: 0 0 3px 2px transparent inset;
    }

    .symbols {
        position: absolute;
        bottom: 0;
        left: 0;
    }

    .slot-symbol:nth-child(1) .symbols {
        transition: bottom 4s ease-in-out;
    }

    .slot-symbol:nth-child(2) .symbols {
        transition: bottom 5.5s ease-in-out;
    }

    .slot-symbol:nth-child(3) .symbols {
        transition: bottom 7s ease-in-out;
    }

    :global(.slot-symbol) {
        width: 110px;
        height: 110px;
        display: block;
        text-align: center;
        padding: 10px;
    }

    :global(img.slot-symbol:not(:last-child):not(:first-child)) {
        filter: blur(1px);
    }

    .icons {
        position: relative;
        transition: .3s;
    }

    .move .icons {
        opacity: 0;
    }

    .icons:before {
        content: "";
        background: #1d2336;
        width: calc(100% + 40px);
        height: 100%;
        position: absolute;
        left: -20px;
        top: 0;
        filter: blur(20px);
        opacity: 0.7;
        border-radius: 30px;
        z-index: -1;
    }

    .icons img {
        width: 60px;
        height: 60px;
    }

    .icons .body {
        margin: 0 50px;
    }

    .move .icons .body {
        margin: 0 5px;
    }

    @media(max-width: 768px) {
        .slot-wrapper {
            zoom: 0.7;
        }

        .move {
            margin: 102px 0 0 116px;
            transform: translate(-50%, -50%) scale(0.72);
        }
    }
</style>
